import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import Translator from "../../Translation/Translator";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* chargeDelete(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CHARGE_DELETE_REQUEST
    });

    const res = yield call(Http.delete, `charge/${action.payload?.charge.id}`);

    yield put({
      type: Constants.GLOBAL_CHARGE_DELETE_SUCCESS
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-charge-removed-successfully"),
        type: "success"
      }
    });

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_CHARGE_DELETE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchChargeDelete() {
  yield takeEvery(Constants.GLOBAL_CHARGE_DELETE_START, chargeDelete);
}
